// extracted by mini-css-extract-plugin
module.exports = {"heading":"b429494557--heading--Qkju4","description":"b429494557--description--FT0PM"};